import useSWR from 'swr';
import {useRouteLoaderData} from 'react-router-dom';
import fetcherWithToken from '@/helpers/fetcherWithToken';

const API_ROUTE =
  'https://admin.ethicssocioeconomics.com/api/1.0/items';

function useItems({identifiedBy}, options = {}) {
  const {userSession} = useRouteLoaderData('root') || {};
  const {data, error, isLoading, mutate, isValidating} = useSWR(
    () =>
      identifiedBy && userSession?.accessToken?.jwtToken
        ? [`${API_ROUTE}?identifiedBy=${identifiedBy}`, userSession?.accessToken?.jwtToken]
        : null,
    ([url, token]) => fetcherWithToken(url, token),
    options
  );

  return {
    items: data?.items,
    isLoading,
    isError: error,
    mutate,
    isValidating,
  };
}

export default useItems;
